import h from "../../../core/createElement";
import DbConnectionPart from "./parts/db_connection_box";
import JsonBodyBox from "./parts/json_body_box";
import ParametersBox from "./parts/parameters_box";


export default function InputsContainer({ parameters, shared, name = "", language, onChangeObject }) {
    const body = {}, inner_shared = {};

    const
        on_change_object = (key) => (object) => {
            body[key] = object;
            onChangeObject && onChangeObject(body);
        };

    shared[name] = {
        patch_values: (request_body_object) => {
            const { paramsform, dbform, jsonform } = inner_shared;

            if (request_body_object.parameters) body.parameters = paramsform.patch_values_object(request_body_object.parameters);

            if (language == "sql" && request_body_object.database) body.database = dbform.patch_values_object(request_body_object.database);
            else if (request_body_object.json) body.json = jsonform.patch_value(request_body_object.json);
        },
        get_initial_object: () => {
            const { paramsform, dbform } = inner_shared;

            body.parameters = paramsform.get_default();

            if (language == "sql") body.database = dbform.get_default();
            else body.json = {};

            return { ...body };
        }
    };

    return (
        <section class="full-size flex-column inner-content">
            {language == "sql" ?
                <DbConnectionPart shared={inner_shared} name="dbform" onChangeObject={on_change_object('database')} />
                :
                <JsonBodyBox shared={inner_shared} name="jsonform" onChangeObject={on_change_object('json')} />
            }
            <ParametersBox parameters={parameters} onChangeObject={on_change_object('parameters')} shared={inner_shared} name="paramsform" />
        </section>
    );
};